import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtualMdfe from '../../actions/mdfe/determinarPaginaAtualMdfe'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoMdfe extends Component {
  render() {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualMdfe}/>
  }
}

export function mapStateToProps(state) {
  return {
    total: state.emissoesMdfe.total,
    paginaAtual: state.paginaAtualMdfe,
    registrosPorPagina: state.registrosPorPaginaMdfe
  }
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({ determinarPaginaAtualMdfe }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoMdfe)
